export const products = [
  {
    id: '1',
    name: '250 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 1625000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5f79b046b3ca67426ebd54e12ac6859e.jpeg',
    gram: 250,
    karat: 24,
    stock: 5,
    description: '250 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '2',
    name: '10 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 65000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5aa761d44aa10613761ea9bf15fe289a.png',
    gram: 10,
    karat: 24,
    stock: 15,
    description: '10 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: false,
    isFeatured: true
  },
  {
    id: '3',
    name: '1 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 6850,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/579e29becdc7de04e6f1be338ed2e12e.png',
    gram: 1,
    karat: 24,
    stock: 50,
    description: '1 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: false,
    isFeatured: false
  },
  {
    id: '4',
    name: '20 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 130000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/0f28d5318d469e0ce2fa8be99469a393.png',
    gram: 20,
    karat: 24,
    stock: 12,
    description: '20 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: false,
    isFeatured: true
  },
  {
    id: '5',
    name: '100 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 650000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/ffd19701a9a4d38479f6260374a10169.png',
    gram: 100,
    karat: 24,
    stock: 8,
    description: '100 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: false,
    isFeatured: true
  },
  {
    id: '6',
    name: '50 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 325000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/c440d9f2ecd84333aec5136e9dd74a34.png',
    gram: 50,
    karat: 24,
    stock: 10,
    description: '50 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: false,
    isFeatured: true
  },
  {
    id: '7',
    name: '5 Gram 24 Ayar Altın',
    category: 'Gram Altın',
    price: 32500,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/08d265ff7c9ef8da8185e8479d0f407f.png',
    gram: 5,
    karat: 24,
    stock: 20,
    description: '5 gram 24 ayar külçe altın. Uluslararası sertifikalı, yatırım amaçlı külçe altın.',
    isNew: false,
    isFeatured: true
  },
  {
    id: '8',
    name: '10 Gr 22 Ayar Düz Ajda Bilezik',
    category: 'Bilezik',
    price: 70000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5c0fe4b16dbae0fbb8199e8d2f08a635.png',
    gram: 10,
    karat: 22,
    stock: 8,
    description: '10 gram 22 ayar düz ajda bilezik. Klasik ve zarif tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '9',
    name: '10 Gr 22 Ayar Düz Ajda Bilezik 2',
    category: 'Bilezik',
    price: 70000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/e2dfc339684d140797ae188d74ff9ac0.png',
    gram: 10,
    karat: 22,
    stock: 7,
    description: '10 gram 22 ayar düz ajda bilezik. Klasik ve zarif tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '10',
    name: '14 Ayar Altın Sevgi Düğümü Ajda Kelepçe Bilezik',
    category: 'Bilezik',
    price: 52000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5ce73421a220bfa9502973835a468bb2.png',
    gram: 8,
    karat: 14,
    stock: 12,
    description: '14 ayar altın sevgi düğümü ajda kelepçe bilezik. Modern ve şık tasarım, özel günler için ideal.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '11',
    name: '14 Ayar Altın Köşeli Gurmet Zincir Bileklik',
    category: 'Bilezik',
    price: 74000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/dfcd81843bd0bf83799ca96532870603.png',
    gram: 12,
    karat: 14,
    stock: 6,
    description: '14 ayar altın köşeli gurmet zincir bileklik. Şık ve modern tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '12',
    name: '14 Ayar Sarı-Beyaz Altın Spark Kıvrım Zincir Bileklik',
    category: 'Bilezik',
    price: 85000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/69288467f5f65422f6dd4671796c7158.png',
    gram: 14,
    karat: 14,
    stock: 9,
    description: '14 ayar sarı-beyaz altın spark kıvrım zincir bileklik. İki renkli altın kombinasyonu ile göz alıcı tasarım.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '13',
    name: 'İşlemeli Kilitli Erzurum Burma Kelepçe Bilezik',
    category: 'Bilezik',
    price: 135000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/379c0058a5e995c7788f6628e814e268.png',
    gram: 20,
    karat: 22,
    stock: 5,
    description: 'İşlemeli kilitli Erzurum burma kelepçe bilezik. Geleneksel Erzurum işçiliği ile özel tasarım, özel günler için ideal.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '14',
    name: 'Tuğra Tokalı Çift Sarmaşık 14 Ayar Kelepçe Bilezik',
    category: 'Bilezik',
    price: 170000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/b22165e4bbbd36a2821b244a2e3be1ca.png',
    gram: 25,
    karat: 14,
    stock: 4,
    description: 'Tuğra tokalı çift sarmaşık 14 ayar kelepçe bilezik. Osmanlı tuğrası detaylı, özel tasarım kelepçe bilezik.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '15',
    name: 'Bombeli Kalp & Su Damlası Altın Charm Bileklik',
    category: 'Bilezik',
    price: 65000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/c9057868669251cd779d5b5c20b80fa5.png',
    gram: 10,
    karat: 14,
    stock: 10,
    description: 'Bombeli kalp ve su damlası altın charm bileklik. Zarif ve romantik tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '16',
    name: '14 Ayar Altın Köşeli Gurmet Zincir Kolye',
    category: 'Kolye',
    price: 175000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/8356258622aec80f572d5a9666a75146.png',
    gram: 28,
    karat: 14,
    stock: 7,
    description: '14 ayar altın köşeli gurmet zincir kolye. Şık ve modern tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '17',
    name: '50 Cm 5 Numara Halat Altın Zincir',
    category: 'Kolye',
    price: 66000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/41b63a78168574a528f4aa6da5d34366.png',
    gram: 9.89,
    karat: 14,
    stock: 8,
    description: '50 cm 5 numara halat altın zincir. 14 ayar altın, klasik ve zarif tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '18',
    name: 'Yonca Motifli 14 Ayar Altın Siyah Sedef Kolye',
    category: 'Kolye',
    price: 32000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/e83fa2fa2e648d4e3ac7004c37c95c2e.png',
    gram: 4.41,
    karat: 14,
    stock: 11,
    description: 'Yonca motifli 14 ayar altın siyah sedef kolye. Zarif yonca motifleri ve siyah sedef detayları ile şık tasarım, günlük kullanıma uygun.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '19',
    name: '14 Ayar Altın Yoğun Dorika Toplu Oval Kolye',
    category: 'Kolye',
    price: 85000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/62d31ac696c5c338b93257da25092874.png',
    gram: 13.17,
    karat: 14,
    stock: 9,
    description: '14 ayar altın yoğun dorika toplu oval kolye. Zarif oval tasarım ve yoğun dorika işçiliği ile göz alıcı kolye, özel günler için ideal.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '20',
    name: '14 Ayar Gurmet Zincir Altın Yüzük',
    category: 'Yüzük',
    price: 33000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/b7625e2811644f77051e4ce90f8723f5.png',
    gram: 3.80,
    karat: 14,
    stock: 15,
    description: '14 ayar gurmet zincir altın yüzük. Modern ve şık gurmet zincir tasarımı ile günlük kullanıma uygun zarif yüzük.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '21',
    name: 'Beypazarı 22 Ayar Altın Yüzük',
    category: 'Yüzük',
    price: 72000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/39fd9955047ffae70c630316076f9347.png',
    gram: 8.32,
    karat: 22,
    stock: 12,
    description: 'Beypazarı 22 ayar altın yüzük. Geleneksel Beypazarı işçiliği ile özel tasarım, günlük kullanıma uygun zarif yüzük.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '22',
    name: '3 Kol Dorikalı 22 Ayar Altın Kadın Yüzük',
    category: 'Yüzük',
    price: 59000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/878cffa695171b719bfc88c0866448e5.png',
    gram: 6.50,
    karat: 22,
    stock: 10,
    description: '3 kol dorikalı 22 ayar altın kadın yüzük. Zarif dorika işçiliği ile üç kol tasarım, günlük kullanıma uygun şık yüzük.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '23',
    name: '22 Ayar Trabzon Hasırı Altın Yüzük',
    category: 'Yüzük',
    price: 35000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/8f5feb7cc6b8f8ff01e5748f92cb7e8d.png',
    gram: 3.52,
    karat: 22,
    stock: 14,
    description: '22 ayar Trabzon hasırı altın yüzük. Geleneksel Trabzon hasır işçiliği ile özel tasarım, günlük kullanıma uygun zarif yüzük.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '24',
    name: 'Eterna Pul Dilimi 14 Ayar Altın Takı Seti',
    category: 'Set',
    price: 155000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/995909b60e25248281703d236068f184.png',
    gram: 24.93,
    karat: 14,
    stock: 6,
    description: 'Eterna pul dilimi 14 ayar altın takı seti. Kolye, küpe ve bileklikten oluşan zarif set, özel günler için ideal.',
    isNew: true,
    isFeatured: true
  },
  {
    id: '25',
    name: 'Kalze Elegant 14 Ayar Altın Takı Seti',
    category: 'Set',
    price: 235000,
    image: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/f76776ec87f01805d62a6deb5f3f5745.png',
    gram: 39.10,
    karat: 14,
    stock: 4,
    description: 'Kalze Elegant 14 ayar altın takı seti. Kolye, küpe ve bileklikten oluşan zarif ve şık set, özel günler için ideal.',
    isNew: true,
    isFeatured: true
  }
];
